import Swiper from "swiper";

export default function () {

    const slidersList = document.querySelectorAll('.teachers-slider');

    slidersList.forEach((slider) => {

        let countSlides = slider.querySelectorAll('.swiper-slide').length;

        let params = {
            slidesPerView: 2,
            slidesPerGroup: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: '.teachers-slider .button-next',
                prevEl: '.teachers-slider .button-prev',
                disabledClass: 'disabled_swiper_button'
            },

            breakpoints: {
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    allowTouchMove: false,
                },
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 800
        };

        if(countSlides > 4) {
            params.loop = true;
        }

        new Swiper(".teachers-slider .swiper-container", params);
    });
}

